export default [
  { code: 'AC', desc: 'Ascension Island' },
  { code: 'AD', desc: 'Andorra' },
  { code: 'AE', desc: 'United Arab Emirates' },
  { code: 'AF', desc: 'Afghanistan' },
  { code: 'AG', desc: 'Antigua & Barbuda' },
  { code: 'AI', desc: 'Anguilla' },
  { code: 'AL', desc: 'Albania' },
  { code: 'AM', desc: 'Armenia' },
  { code: 'AO', desc: 'Angola' },
  { code: 'AQ', desc: 'Antarctica' },
  { code: 'AR', desc: 'Argentina' },
  { code: 'AS', desc: 'American Samoa' },
  { code: 'AT', desc: 'Austria' },
  { code: 'AU', desc: 'Australia' },
  { code: 'AW', desc: 'Aruba' },
  { code: 'AX', desc: 'Åland Islands' },
  { code: 'AZ', desc: 'Azerbaijan' },
  { code: 'BA', desc: 'Bosnia & Herzegovina' },
  { code: 'BB', desc: 'Barbados' },
  { code: 'BD', desc: 'Bangladesh' },
  { code: 'BE', desc: 'Belgium' },
  { code: 'BF', desc: 'Burkina Faso' },
  { code: 'BG', desc: 'Bulgaria' },
  { code: 'BH', desc: 'Bahrain' },
  { code: 'BI', desc: 'Burundi' },
  { code: 'BJ', desc: 'Benin' },
  { code: 'BL', desc: 'St Barthélemy' },
  { code: 'BM', desc: 'Bermuda' },
  { code: 'BN', desc: 'Brunei' },
  { code: 'BO', desc: 'Bolivia' },
  { code: 'BQ', desc: 'Caribbean Netherlands' },
  { code: 'BR', desc: 'Brazil' },
  { code: 'BS', desc: 'Bahamas' },
  { code: 'BT', desc: 'Bhutan' },
  { code: 'BV', desc: 'Bouvet Island' },
  { code: 'BW', desc: 'Botswana' },
  { code: 'BY', desc: 'Belarus' },
  { code: 'BZ', desc: 'Belize' },
  { code: 'CA', desc: 'Canada' },
  { code: 'CC', desc: 'Cocos [Keeling] Islands' },
  { code: 'CD', desc: 'Democratic Republic of Congo' },
  { code: 'CF', desc: 'Central African Republic' },
  { code: 'CG', desc: 'Congo - Brazzaville' },
  { code: 'CH', desc: 'Switzerland' },
  { code: 'CI', desc: 'Côte d’Ivoire' },
  { code: 'CK', desc: 'Cook Islands' },
  { code: 'CL', desc: 'Chile' },
  { code: 'CM', desc: 'Cameroon' },
  { code: 'CN', desc: 'China', desc1: 'china' },
  { code: 'CO', desc: 'Colombia' },
  { code: 'CP', desc: 'Clipperton Island' },
  { code: 'CR', desc: 'Costa Rica' },
  { code: 'CU', desc: 'Cuba' },
  { code: 'CV', desc: 'Cape Verde' },
  { code: 'CW', desc: 'Curaçao' },
  { code: 'CX', desc: 'Christmas Island' },
  { code: 'CY', desc: 'Cyprus' },
  { code: 'CZ', desc: 'Czechia' },
  { code: 'DE', desc: 'Germany' },
  { code: 'DG', desc: 'Diego Garcia' },
  { code: 'DJ', desc: 'Djibouti' },
  { code: 'DK', desc: 'Denmark' },
  { code: 'DM', desc: 'Dominica' },
  { code: 'DO', desc: 'Dominican Republic' },
  { code: 'DZ', desc: 'Algeria' },
  { code: 'EA', desc: 'Ceuta & Melilla' },
  { code: 'EC', desc: 'Ecuador' },
  { code: 'EE', desc: 'Estonia' },
  { code: 'EG', desc: 'Egypt' },
  { code: 'EH', desc: 'Western Sahara' },
  { code: 'ER', desc: 'Eritrea' },
  { code: 'ES', desc: 'Spain' },
  { code: 'ET', desc: 'Ethiopia' },
  { code: 'FI', desc: 'Finland' },
  { code: 'FJ', desc: 'Fiji' },
  { code: 'FK', desc: 'Falkland Islands' },
  { code: 'FM', desc: 'Micronesia' },
  { code: 'FO', desc: 'Faroe Islands' },
  { code: 'FR', desc: 'France' },
  { code: 'GA', desc: 'Gabon' },
  { code: 'GB', desc: 'United Kingdom' },
  { code: 'GD', desc: 'Grenada' },
  { code: 'GE', desc: 'Georgia' },
  { code: 'GF', desc: 'French Guiana' },
  { code: 'GG', desc: 'Guernsey' },
  { code: 'GH', desc: 'Ghana' },
  { code: 'GI', desc: 'Gibraltar' },
  { code: 'GL', desc: 'Greenland' },
  { code: 'GM', desc: 'Gambia' },
  { code: 'GN', desc: 'Guinea' },
  { code: 'GP', desc: 'Guadeloupe' },
  { code: 'GQ', desc: 'Equatorial Guinea' },
  { code: 'GR', desc: 'Greece' },
  { code: 'GS', desc: 'So. Georgia & So. Sandwich Isl.' },
  { code: 'GT', desc: 'Guatemala' },
  { code: 'GU', desc: 'Guam' },
  { code: 'GW', desc: 'Guinea-Bissau' },
  { code: 'GY', desc: 'Guyana' },
  { code: 'HK', desc: 'Hong Kong', desc1: 'china' },
  { code: 'HM', desc: 'Heard & McDonald Islands' },
  { code: 'HN', desc: 'Honduras' },
  { code: 'HR', desc: 'Croatia' },
  { code: 'HT', desc: 'Haiti' },
  { code: 'HU', desc: 'Hungary' },
  { code: 'IC', desc: 'Canary Islands' },
  { code: 'ID', desc: 'Indonesia' },
  { code: 'IE', desc: 'Ireland' },
  { code: 'IL', desc: 'Israel' },
  { code: 'IM', desc: 'Isle of Man' },
  { code: 'IN', desc: 'India' },
  { code: 'IO', desc: 'British Indian Ocean Territory' },
  { code: 'IQ', desc: 'Iraq' },
  { code: 'IR', desc: 'Iran' },
  { code: 'IS', desc: 'Iceland' },
  { code: 'IT', desc: 'Italy' },
  { code: 'JE', desc: 'Jersey' },
  { code: 'JM', desc: 'Jamaica' },
  { code: 'JO', desc: 'Jordan' },
  { code: 'JP', desc: 'Japan' },
  { code: 'KE', desc: 'Kenya' },
  { code: 'KG', desc: 'Kyrgyzstan' },
  { code: 'KH', desc: 'Cambodia' },
  { code: 'KI', desc: 'Kiribati' },
  { code: 'KM', desc: 'Comoros' },
  { code: 'KN', desc: 'St Kitts & Nevis' },
  { code: 'KP', desc: 'North Korea' },
  { code: 'KR', desc: 'South Korea' },
  { code: 'KW', desc: 'Kuwait' },
  { code: 'KY', desc: 'Cayman Islands' },
  { code: 'KZ', desc: 'Kazakhstan' },
  { code: 'LA', desc: 'Laos' },
  { code: 'LB', desc: 'Lebanon' },
  { code: 'LC', desc: 'St Lucia' },
  { code: 'LI', desc: 'Liechtenstein' },
  { code: 'LK', desc: 'Sri Lanka' },
  { code: 'LR', desc: 'Liberia' },
  { code: 'LS', desc: 'Lesotho' },
  { code: 'LT', desc: 'Lithuania' },
  { code: 'LU', desc: 'Luxembourg' },
  { code: 'LV', desc: 'Latvia' },
  { code: 'LY', desc: 'Libya' },
  { code: 'MA', desc: 'Morocco' },
  { code: 'MC', desc: 'Monaco' },
  { code: 'MD', desc: 'Moldova' },
  { code: 'ME', desc: 'Montenegro' },
  { code: 'MF', desc: 'St Martin' },
  { code: 'MG', desc: 'Madagascar' },
  { code: 'MH', desc: 'Marshall Islands' },
  { code: 'MK', desc: 'Macedonia' },
  { code: 'ML', desc: 'Mali' },
  { code: 'MM', desc: 'Myanmar [Burma]' },
  { code: 'MN', desc: 'Mongolia' },
  { code: 'MO', desc: 'Macao', desc1: 'china' },
  { code: 'MP', desc: 'Northern Mariana Islands' },
  { code: 'MQ', desc: 'Martinique' },
  { code: 'MR', desc: 'Mauritania' },
  { code: 'MS', desc: 'Montserrat' },
  { code: 'MT', desc: 'Malta' },
  { code: 'MU', desc: 'Mauritius' },
  { code: 'MV', desc: 'Maldives' },
  { code: 'MW', desc: 'Malawi' },
  { code: 'MX', desc: 'Mexico' },
  { code: 'MY', desc: 'Malaysia' },
  { code: 'MZ', desc: 'Mozambique' },
  { code: 'NA', desc: 'Namibia' },
  { code: 'NC', desc: 'New Caledonia' },
  { code: 'NE', desc: 'Niger' },
  { code: 'NF', desc: 'Norfolk Island' },
  { code: 'NG', desc: 'Nigeria' },
  { code: 'NI', desc: 'Nicaragua' },
  { code: 'NL', desc: 'Netherlands' },
  { code: 'NO', desc: 'Norway' },
  { code: 'NP', desc: 'Nepal' },
  { code: 'NR', desc: 'Nauru' },
  { code: 'NU', desc: 'Niue' },
  { code: 'NZ', desc: 'New Zealand' },
  { code: 'OM', desc: 'Oman' },
  { code: 'PA', desc: 'Panama' },
  { code: 'PE', desc: 'Peru' },
  { code: 'PF', desc: 'French Polynesia' },
  { code: 'PG', desc: 'Papua New Guinea' },
  { code: 'PH', desc: 'Philippines' },
  { code: 'PK', desc: 'Pakistan' },
  { code: 'PL', desc: 'Poland' },
  { code: 'PM', desc: 'St Pierre & Miquelon' },
  { code: 'PN', desc: 'Pitcairn Islands' },
  { code: 'PR', desc: 'Puerto Rico' },
  { code: 'PS', desc: 'Palestinian Territories' },
  { code: 'PT', desc: 'Portugal' },
  { code: 'PW', desc: 'Palau' },
  { code: 'PY', desc: 'Paraguay' },
  { code: 'QA', desc: 'Qatar' },
  { code: 'RE', desc: 'Réunion' },
  { code: 'RO', desc: 'Romania' },
  { code: 'RS', desc: 'Serbia' },
  { code: 'RU', desc: 'Russia' },
  { code: 'RW', desc: 'Rwanda' },
  { code: 'SA', desc: 'Saudi Arabia' },
  { code: 'SB', desc: 'Solomon Islands' },
  { code: 'SC', desc: 'Seychelles' },
  { code: 'SD', desc: 'Sudan' },
  { code: 'SE', desc: 'Sweden' },
  { code: 'SG', desc: 'Singapore' },
  { code: 'SH', desc: 'St Helena' },
  { code: 'SI', desc: 'Slovenia' },
  { code: 'SJ', desc: 'Svalbard & Jan Mayen' },
  { code: 'SK', desc: 'Slovakia' },
  { code: 'SL', desc: 'Sierra Leone' },
  { code: 'SM', desc: 'San Marino' },
  { code: 'SN', desc: 'Senegal' },
  { code: 'SO', desc: 'Somalia' },
  { code: 'SR', desc: 'Suriname' },
  { code: 'SS', desc: 'South Sudan' },
  { code: 'ST', desc: 'São Tomé & Príncipe' },
  { code: 'SV', desc: 'El Salvador' },
  { code: 'SX', desc: 'Sint Maarten' },
  { code: 'SY', desc: 'Syria' },
  { code: 'SZ', desc: 'Swaziland' },
  { code: 'TA', desc: 'Tristan da Cunha' },
  { code: 'TC', desc: 'Turks & Caicos Islands' },
  { code: 'TD', desc: 'Chad' },
  { code: 'TF', desc: 'French Southern Territories' },
  { code: 'TG', desc: 'Togo' },
  { code: 'TH', desc: 'Thailand' },
  { code: 'TJ', desc: 'Tajikistan' },
  { code: 'TK', desc: 'Tokelau' },
  { code: 'TL', desc: 'Timor-Leste' },
  { code: 'TM', desc: 'Turkmenistan' },
  { code: 'TN', desc: 'Tunisia' },
  { code: 'TO', desc: 'Tonga' },
  { code: 'TR', desc: 'Turkey' },
  { code: 'TT', desc: 'Trinidad & Tobago' },
  { code: 'TV', desc: 'Tuvalu' },
  { code: 'TW', desc: 'Taiwan, Province of China', desc1: 'china' },
  { code: 'TZ', desc: 'Tanzania' },
  { code: 'UA', desc: 'Ukraine' },
  { code: 'UG', desc: 'Uganda' },
  { code: 'UM', desc: 'US Outlying Islands' },
  { code: 'US', desc: 'United States of America' },
  { code: 'UY', desc: 'Uruguay' },
  { code: 'UZ', desc: 'Uzbekistan' },
  { code: 'VA', desc: 'Vatican City' },
  { code: 'VC', desc: 'St Vincent & Grenadines' },
  { code: 'VE', desc: 'Venezuela' },
  { code: 'VG', desc: 'British Virgin Islands' },
  { code: 'VI', desc: 'US Virgin Islands' },
  { code: 'VN', desc: 'Vietnam' },
  { code: 'VU', desc: 'Vanuatu' },
  { code: 'WF', desc: 'Wallis & Futuna' },
  { code: 'WS', desc: 'Samoa' },
  { code: 'XK', desc: 'Kosovo' },
  { code: 'YE', desc: 'Yemen' },
  { code: 'YT', desc: 'Mayotte' },
  { code: 'ZA', desc: 'South Africa' },
  { code: 'ZM', desc: 'Zambia' },
  { code: 'ZW', desc: 'Zimbabwe' },
  { code: 'DNR', desc: 'Donetsk' },
  { code: 'LNR', desc: 'Luhansk' },
  { code: 'XKX', desc: 'Kosovo' },
]

export const countryNameMap = {
  XKX: { cn: '科索沃', code: 'XKX', desc: 'Kosovo', flag: '🇽🇰' },
  AD: { cn: '安道尔', code: 'AD', desc: 'Andorra', flag: '🇦🇩' },
  AE: { cn: '阿联酋', code: 'AE', desc: 'United Arab Emirates', flag: '🇦🇪' },
  AF: { cn: '阿富汗', code: 'AF', desc: 'Afghanistan', flag: '🇦🇫' },
  AG: { cn: '安提瓜和巴布达', code: 'AG', desc: 'Antigua & Barbuda', flag: '🇦🇬' },
  AI: { cn: '安圭拉', code: 'AI', desc: 'Anguilla', flag: '🇦🇮' },
  AL: { cn: '阿尔巴尼亚', code: 'AL', desc: 'Albania', flag: '🇦🇱' },
  AM: { cn: '亚美尼亚', code: 'AM', desc: 'Armenia', flag: '🇦🇲' },
  AO: { cn: '安哥拉', code: 'AO', desc: 'Angola', flag: '🇦🇴' },
  AQ: { cn: '南极洲', code: 'AQ', desc: 'Antarctica', flag: '🇦🇶' },
  AR: { cn: '阿根廷', code: 'AR', desc: 'Argentina', flag: '🇦🇷' },
  AS: { cn: '美属萨摩亚', code: 'AS', desc: 'American Samoa', flag: '🇦🇸' },
  AT: { cn: '奥地利', code: 'AT', desc: 'Austria', flag: '🇦🇹' },
  AU: { cn: '澳大利亚', code: 'AU', desc: 'Australia', flag: '🇦🇺' },
  AW: { cn: '阿鲁巴', code: 'AW', desc: 'Aruba', flag: '🇦🇼' },
  AX: { cn: '奥兰', code: 'AX', desc: 'Åland Islands', flag: '🇦🇽' },
  AZ: { cn: '阿塞拜疆', code: 'AZ', desc: 'Azerbaijan', flag: '🇦🇿' },
  BA: { cn: '波黑', code: 'BA', desc: 'Bosnia & Herzegovina', flag: '🇧🇦' },
  BB: { cn: '巴巴多斯', code: 'BB', desc: 'Barbados', flag: '🇧🇧' },
  BD: { cn: '孟加拉国', code: 'BD', desc: 'Bangladesh', flag: '🇧🇩' },
  BE: { cn: '比利时', code: 'BE', desc: 'Belgium', flag: '🇧🇪' },
  BF: { cn: '布基纳法索', code: 'BF', desc: 'Burkina Faso', flag: '🇧🇫' },
  BG: { cn: '保加利亚', code: 'BG', desc: 'Bulgaria', flag: '🇧🇬' },
  BH: { cn: '巴林', code: 'BH', desc: 'Bahrain', flag: '🇧🇭' },
  BI: { cn: '布隆迪', code: 'BI', desc: 'Burundi', flag: '🇧🇮' },
  BJ: { cn: '贝宁', code: 'BJ', desc: 'Benin', flag: '🇧🇯' },
  BL: { cn: '圣巴泰勒米', code: 'BL', desc: 'St Barthélemy', flag: '🇧🇱' },
  BLK: { cn: '巴尔干半岛', code: 'BLK', desc: 'Balkans', flag: 'x' },
  BM: { cn: '百慕大', code: 'BM', desc: 'Bermuda', flag: '🇧🇲' },
  BN: { cn: '文莱', code: 'BN', desc: 'Brunei', flag: '🇧🇳' },
  BO: { cn: '玻利维亚', code: 'BO', desc: 'Bolivia', flag: '🇧🇴' },
  BQ: { cn: '荷兰加勒比区', code: 'BQ', desc: 'Caribbean Netherlands', flag: '🇧🇶' },
  BR: { cn: '巴西', code: 'BR', desc: 'Brazil', flag: '🇧🇷' },
  BS: { cn: '巴哈马', code: 'BS', desc: 'Bahamas', flag: '🇧🇸' },
  BT: { cn: '不丹', code: 'BT', desc: 'Bhutan', flag: '🇧🇹' },
  BV: { cn: '布韦岛', code: 'BV', desc: 'Bouvet Island', flag: '🇧🇻' },
  BW: { cn: '博茨瓦纳', code: 'BW', desc: 'Botswana', flag: '🇧🇼' },
  BY: { cn: '白俄罗斯', code: 'BY', desc: 'Belarus', flag: '🇧🇾' },
  BZ: { cn: '伯利兹', code: 'BZ', desc: 'Belize', flag: '🇧🇿' },
  CA: { cn: '加拿大', code: 'CA', desc: 'Canada', flag: '🇨🇦' },
  CC: { cn: '科科斯（基林）群岛', code: 'CC', desc: 'Cocos [Keeling] Islands', flag: '🇨🇨' },
  CD: { cn: '刚果民主共和国', code: 'CD', desc: 'Democratic Republic of Congo', flag: '🇨🇩' },
  CF: { cn: '中非', code: 'CF', desc: 'Central African Republic', flag: '🇨🇫' },
  CG: { cn: '刚果共和国', code: 'CG', desc: 'Congo - Brazzaville', flag: '🇨🇩' },
  CH: { cn: '瑞士', code: 'CH', desc: 'Switzerland', flag: '🇨🇭' },
  CI: { cn: '科特迪瓦', code: 'CI', desc: 'Cote D’Ivoire (Ivory Coast)', flag: '🇨🇮' },
  CK: { cn: '库克群岛', code: 'CK', desc: 'Cook Islands', flag: '🇨🇰' },
  CL: { cn: '智利', code: 'CL', desc: 'Chile', flag: '🇨🇱' },
  CM: { cn: '喀麦隆', code: 'CM', desc: 'Cameroon', flag: '🇨🇲' },
  CN: { cn: '中国(大陆)', code: 'CN', desc: 'China(Mainland)', desc1: 'China(Mainland)', flag: '🇨🇳' },
  CO: { cn: '哥伦比亚', code: 'CO', desc: 'Colombia', flag: '🇨🇴' },
  CR: { cn: '哥斯达黎加', code: 'CR', desc: 'Costa Rica', flag: '🇨🇷' },
  CRM: { cn: '克里米亚', code: 'CRM', desc: 'Crimea', flag: 'x' },
  CU: { cn: '古巴', code: 'CU', desc: 'Cuba', flag: '🇨🇺' },
  CV: { cn: '佛得角', code: 'CV', desc: 'Cape Verde', flag: '🇨🇻' },
  CW: { cn: '库拉索', code: 'CW', desc: 'Curaçao', flag: '🇨🇼' },
  CX: { cn: '圣诞岛', code: 'CX', desc: 'Christmas Island', flag: '🇨🇽' },
  CY: { cn: '塞浦路斯', code: 'CY', desc: 'Cyprus', flag: '🇨🇾' },
  CZ: { cn: '捷克', code: 'CZ', desc: 'Czechia', flag: '🇨🇿' },
  DE: { cn: '德国', code: 'DE', desc: 'Germany', flag: '🇩🇪' },
  DJ: { cn: '吉布提', code: 'DJ', desc: 'Djibouti', flag: '🇩🇯' },
  DK: { cn: '丹麦', code: 'DK', desc: 'Denmark', flag: '🇩🇰' },
  DM: { cn: '多米尼克', code: 'DM', desc: 'Dominica', flag: '🇩🇲' },
  DO: { cn: '多米尼加', code: 'DO', desc: 'Dominican Republic', flag: '🇩🇲' },
  DZ: { cn: '阿尔及利亚', code: 'DZ', desc: 'Algeria', flag: '🇩🇿' },
  EC: { cn: '厄瓜多尔', code: 'EC', desc: 'Ecuador', flag: '🇪🇨' },
  EE: { cn: '爱沙尼亚', code: 'EE', desc: 'Estonia', flag: '🇪🇪' },
  EG: { cn: '埃及', code: 'EG', desc: 'Egypt', flag: '🇪🇬' },
  EH: { cn: '西撒哈拉', code: 'EH', desc: 'Western Sahara', flag: '🇪🇭' },
  ER: { cn: '厄立特里亚', code: 'ER', desc: 'Eritrea', flag: '🇪🇷' },
  ES: { cn: '西班牙', code: 'ES', desc: 'Spain', flag: '🇪🇸' },
  ET: { cn: '埃塞俄比亚', code: 'ET', desc: 'Ethiopia', flag: '🇪🇹' },
  FI: { cn: '芬兰', code: 'FI', desc: 'Finland', flag: '🇫🇮' },
  FJ: { cn: '斐济', code: 'FJ', desc: 'Fiji', flag: '🇫🇯' },
  FK: { cn: '福克兰群岛', code: 'FK', desc: 'Falkland Islands', flag: '🇫🇰' },
  FM: { cn: '密克罗尼西亚联邦', code: 'FM', desc: 'Micronesia', flag: '🇫🇲' },
  FO: { cn: '法罗群岛', code: 'FO', desc: 'Faroe Islands', flag: '🇫🇴' },
  FR: { cn: '法国', code: 'FR', desc: 'France', flag: '🇫🇷' },
  GA: { cn: '加蓬', code: 'GA', desc: 'Gabon', flag: '🇬🇦' },
  GB: { cn: '英国', code: 'GB', desc: 'United Kingdom', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿' },
  GD: { cn: '格林纳达', code: 'GD', desc: 'Grenada', flag: '🇬🇩' },
  GE: { cn: '格鲁吉亚', code: 'GE', desc: 'Georgia', flag: '🇬🇪' },
  GF: { cn: '法属圭亚那', code: 'GF', desc: 'French Guiana', flag: '🇬🇫' },
  GG: { cn: '根西', code: 'GG', desc: 'Guernsey', flag: '🇬🇬' },
  GH: { cn: '加纳', code: 'GH', desc: 'Ghana', flag: '🇬🇭' },
  GI: { cn: '直布罗陀', code: 'GI', desc: 'Gibraltar', flag: '🇬🇮' },
  GL: { cn: '格陵兰', code: 'GL', desc: 'Greenland', flag: '🇬🇱' },
  GM: { cn: '冈比亚', code: 'GM', desc: 'Gambia', flag: '🇬🇲' },
  GN: { cn: '几内亚', code: 'GN', desc: 'Guinea', flag: '🇬🇳' },
  GP: { cn: '瓜德罗普', code: 'GP', desc: 'Guadeloupe', flag: '🇬🇵' },
  GQ: { cn: '赤道几内亚', code: 'GQ', desc: 'Equatorial Guinea', flag: '🇬🇶' },
  GR: { cn: '希腊', code: 'GR', desc: 'Greece', flag: '🇬🇷' },
  GS: {
    cn: '南乔治亚和南桑威奇群岛',
    code: 'GS',
    desc: 'So. Georgia & So. Sandwich Isl.',
    flag: '🇬🇸',
  },
  GT: { cn: '危地马拉', code: 'GT', desc: 'Guatemala', flag: '🇬🇹' },
  GU: { cn: '关岛', code: 'GU', desc: 'Guam', flag: '🇬🇺' },
  GW: { cn: '几内亚比绍', code: 'GW', desc: 'Guinea-Bissau', flag: '🇬🇼' },
  GY: { cn: '圭亚那', code: 'GY', desc: 'Guyana', flag: '🇬🇾' },
  HK: { cn: '中国香港', code: 'HK', desc: 'Hong Kong', desc1: 'china', flag: '🇭🇰' },
  HM: {
    cn: '赫德岛和麦克唐纳群岛',
    code: 'HM',
    desc: 'Heard & McDonald Islands',
    flag: '🇭🇲',
  },
  HN: { cn: '洪都拉斯', code: 'HN', desc: 'Honduras', flag: '🇭🇳' },
  HR: { cn: '克罗地亚', code: 'HR', desc: 'Croatia', flag: '🇭🇷' },
  HT: { cn: '海地', code: 'HT', desc: 'Haiti', flag: '🇭🇹' },
  HU: { cn: '匈牙利', code: 'HU', desc: 'Hungary', flag: '🇭🇺' },
  ID: { cn: '印尼', code: 'ID', desc: 'Indonesia', flag: '🇮🇩' },
  IE: { cn: '爱尔兰', code: 'IE', desc: 'Ireland', flag: '🇮🇪' },
  IL: { cn: '以色列', code: 'IL', desc: 'Israel', flag: '🇮🇱' },
  IM: { cn: '马恩岛', code: 'IM', desc: 'Isle of Man', flag: '🇮🇲' },
  IN: { cn: '印度', code: 'IN', desc: 'India', flag: '🇮🇳' },
  IO: {
    cn: '英属印度洋领地',
    code: 'IO',
    desc: 'British Indian Ocean Territory',
    flag: '🇮🇴',
  },
  IQ: { cn: '伊拉克', code: 'IQ', desc: 'Iraq', flag: '🇮🇶' },
  IR: { cn: '伊朗', code: 'IR', desc: 'Iran', flag: '🇮🇷' },
  IS: { cn: '冰岛', code: 'IS', desc: 'Iceland', flag: '🇮🇸' },
  IT: { cn: '意大利', code: 'IT', desc: 'Italy', flag: '🇮🇹' },
  JE: { cn: '泽西', code: 'JE', desc: 'Jersey', flag: '🇯🇪' },
  JM: { cn: '牙买加', code: 'JM', desc: 'Jamaica', flag: '🇯🇲' },
  JO: { cn: '约旦', code: 'JO', desc: 'Jordan', flag: '🇯🇴' },
  JP: { cn: '日本', code: 'JP', desc: 'Japan', flag: '🇯🇵' },
  KE: { cn: '肯尼亚', code: 'KE', desc: 'Kenya', flag: '🇰🇪' },
  KG: { cn: '吉尔吉斯斯坦', code: 'KG', desc: 'Kyrgyzstan', flag: '🇰🇬' },
  KH: { cn: '柬埔寨', code: 'KH', desc: 'Cambodia', flag: '🇰🇭' },
  KI: { cn: '基里巴斯', code: 'KI', desc: 'Kiribati', flag: '🇰🇮' },
  KM: { cn: '科摩罗', code: 'KM', desc: 'Comoros', flag: '🇰🇲' },
  KN: { cn: '圣基茨和尼维斯', code: 'KN', desc: 'St Kitts & Nevis', flag: '🇰🇳' },
  KP: { cn: '朝鲜', code: 'KP', desc: 'North Korea', flag: '🇰🇵' },
  KR: { cn: '韩国', code: 'KR', desc: 'South Korea', flag: '🇰🇷' },
  KW: { cn: '科威特', code: 'KW', desc: 'Kuwait', flag: '🇰🇼' },
  KY: { cn: '开曼群岛', code: 'KY', desc: 'Cayman Islands', flag: '🇰🇾' },
  KZ: { cn: '哈萨克斯坦', code: 'KZ', desc: 'Kazakhstan', flag: '🇰🇿' },
  LA: { cn: '老挝', code: 'LA', desc: 'Laos', flag: '🇱🇦' },
  LB: { cn: '黎巴嫩', code: 'LB', desc: 'Lebanon', flag: '🇱🇧' },
  LC: { cn: '圣卢西亚', code: 'LC', desc: 'St Lucia', flag: '🇱🇨' },
  LDNR: {
    cn: '以及所谓顿涅茨克人民共和国(DNR)或卢甘斯克人民共和国(LNR)',
    code: 'LDNR',
    desc: "the so-called Donetsk People's Republic (DNR)  or  Luhansk People's Republic (LNR)",
    flag: 'x',
  },
  LI: { cn: '列支敦士登', code: 'LI', desc: 'Liechtenstein', flag: '🇱🇮' },
  LK: { cn: '斯里兰卡', code: 'LK', desc: 'Sri Lanka', flag: '🇱🇰' },
  LR: { cn: '利比里亚', code: 'LR', desc: 'Liberia', flag: '🇱🇷' },
  LS: { cn: '莱索托', code: 'LS', desc: 'Lesotho', flag: '🇱🇸' },
  LT: { cn: '立陶宛', code: 'LT', desc: 'Lithuania', flag: '🇱🇹' },
  LU: { cn: '卢森堡', code: 'LU', desc: 'Luxembourg', flag: '🇱🇺' },
  LV: { cn: '拉脱维亚', code: 'LV', desc: 'Latvia', flag: '🇱🇻' },
  LY: { cn: '利比亚', code: 'LY', desc: 'Libya', flag: '🇱🇾' },
  MA: { cn: '摩洛哥', code: 'MA', desc: 'Morocco', flag: '🇲🇦' },
  MC: { cn: '摩纳哥', code: 'MC', desc: 'Monaco', flag: '🇲🇨' },
  MD: { cn: '摩尔多瓦', code: 'MD', desc: 'Moldova', flag: '🇲🇩' },
  ME: { cn: '黑山', code: 'ME', desc: 'Montenegro', flag: '🇲🇪' },
  MF: { cn: '法属圣马丁', code: 'MF', desc: 'St Martin', flag: '🇲🇫' },
  MG: { cn: '马达加斯加', code: 'MG', desc: 'Madagascar', flag: '🇲🇬' },
  MH: { cn: '马绍尔群岛', code: 'MH', desc: 'Marshall Islands', flag: '🇲🇭' },
  MK: { cn: '北马其顿', code: 'MK', desc: 'Macedonia', flag: '🇲🇰' },
  ML: { cn: '马里', code: 'ML', desc: 'Mali', flag: '🇲🇱' },
  MM: { cn: '缅甸', code: 'MM', desc: 'Burma', flag: '🇲🇲' },
  MN: { cn: '蒙古', code: 'MN', desc: 'Mongolia', flag: '🇲🇳' },
  MO: { cn: '中国澳门', code: 'MO', desc: 'Macao', desc1: 'china', flag: '🇲🇴' },
  MP: { cn: '北马里亚纳群岛', code: 'MP', desc: 'Northern Mariana Islands', flag: '🇲🇵' },
  MQ: { cn: '马提尼克', code: 'MQ', desc: 'Martinique', flag: '🇲🇶' },
  MR: { cn: '毛里塔尼亚', code: 'MR', desc: 'Mauritania', flag: '🇲🇷' },
  MS: { cn: '蒙特塞拉特', code: 'MS', desc: 'Montserrat', flag: '🇲🇸' }, // !!!!!!!
  MT: { cn: '马耳他', code: 'MT', desc: 'Malta', flag: '🇲🇹' },
  MU: { cn: '毛里求斯', code: 'MU', desc: 'Mauritius', flag: '🇲🇺' },
  MV: { cn: '马尔代夫', code: 'MV', desc: 'Maldives', flag: '🇲🇻' },
  MW: { cn: '马拉维', code: 'MW', desc: 'Malawi', flag: '🇲🇼' },
  MX: { cn: '墨西哥', code: 'MX', desc: 'Mexico', flag: '🇲🇽' },
  MY: { cn: '马来西亚', code: 'MY', desc: 'Malaysia', flag: '🇲🇾' },
  MZ: { cn: '莫桑比克', code: 'MZ', desc: 'Mozambique', flag: '🇲🇿' },
  NA: { cn: '纳米比亚', code: 'NA', desc: 'Namibia', flag: '🇳🇦' },
  NC: { cn: '新喀里多尼亚', code: 'NC', desc: 'New Caledonia', flag: '🇳🇨' },
  NE: { cn: '尼日尔', code: 'NE', desc: 'Niger', flag: '🇳🇪' },
  NF: { cn: '诺福克岛', code: 'NF', desc: 'Norfolk Island', flag: '🇳🇫' },
  NG: { cn: '尼日利亚', code: 'NG', desc: 'Nigeria', flag: '🇳🇬' },
  NI: { cn: '尼加拉瓜', code: 'NI', desc: 'Nicaragua', flag: '🇳🇮' },
  NL: { cn: '荷兰', code: 'NL', desc: 'Netherlands', flag: '🇳🇱' },
  NO: { cn: '挪威', code: 'NO', desc: 'Norway', flag: '🇳🇴' },
  NP: { cn: '尼泊尔', code: 'NP', desc: 'Nepal', flag: '🇳🇵' },
  NR: { cn: '瑙鲁', code: 'NR', desc: 'Nauru', flag: '🇳🇷' },
  NYK: { cn: '纽约州', code: 'NYK', desc: 'the State of New York', flag: '🇺🇸' },
  NU: { cn: '纽埃', code: 'NU', desc: 'Niue', flag: '🇳🇺' },
  NZ: { cn: '新西兰', code: 'NZ', desc: 'New Zealand', flag: '🇳🇿' },
  OM: { cn: '阿曼', code: 'OM', desc: 'Oman', flag: '🇴🇲' },
  PA: { cn: '巴拿马', code: 'PA', desc: 'Panama', flag: '🇵🇦' },
  PE: { cn: '秘鲁', code: 'PE', desc: 'Peru', flag: '🇵🇪' },
  PF: { cn: '法属波利尼西亚', code: 'PF', desc: 'French Polynesia', flag: '🇵🇫' },
  PG: { cn: '巴布亚新几内亚', code: 'PG', desc: 'Papua New Guinea', flag: '🇵🇬' },
  PH: { cn: '菲律宾', code: 'PH', desc: 'Philippines', flag: '🇵🇭' },
  PK: { cn: '巴基斯坦', code: 'PK', desc: 'Pakistan', flag: '🇵🇰' },
  PL: { cn: '波兰', code: 'PL', desc: 'Poland', flag: '🇵🇱' },
  PM: { cn: '圣皮埃尔和密克隆', code: 'PM', desc: 'St Pierre & Miquelon', flag: '🇵🇲' },
  PN: { cn: '皮特凯恩群岛', code: 'PN', desc: 'Pitcairn Islands', flag: '🇵🇳' },
  PR: { cn: '波多黎各', code: 'PR', desc: 'Puerto Rico', flag: '🇵🇷' },
  PS: { cn: '巴勒斯坦', code: 'PS', desc: 'Palestinian Territories', flag: '🇵🇸' },
  PT: { cn: '葡萄牙', code: 'PT', desc: 'Portugal', flag: '🇵🇹' },
  PW: { cn: '帕劳', code: 'PW', desc: 'Palau', flag: '🇵🇼' },
  PY: { cn: '巴拉圭', code: 'PY', desc: 'Paraguay', flag: '🇵🇾' },
  QA: { cn: '卡塔尔', code: 'QA', desc: 'Qatar', flag: '🇶🇦' },
  RE: { cn: '留尼汪', code: 'RE', desc: 'Réunion', flag: '🇷🇪' },
  RO: { cn: '罗马尼亚', code: 'RO', desc: 'Romania', flag: '🇷🇴' },
  RS: { cn: '塞尔维亚', code: 'RS', desc: 'Serbia', flag: '🇷🇸' },
  RU: { cn: '俄罗斯', code: 'RU', desc: 'Russia', flag: '🇷🇺' },
  RW: { cn: '卢旺达', code: 'RW', desc: 'Rwanda', flag: '🇷🇼' },
  SA: { cn: '沙特阿拉伯', code: 'SA', desc: 'Saudi Arabia', flag: '🇸🇦' },
  SB: { cn: '所罗门群岛', code: 'SB', desc: 'Solomon Islands', flag: '🇸🇧' },
  SC: { cn: '塞舌尔', code: 'SC', desc: 'Seychelles', flag: '🇸🇨' },
  SD: { cn: '苏丹', code: 'SD', desc: 'Sudan', flag: '🇸🇩' },
  SE: { cn: '瑞典', code: 'SE', desc: 'Sweden', flag: '🇸🇪' },
  SG: { cn: '新加坡', code: 'SG', desc: 'Singapore', flag: '🇸🇬' },
  SH: {
    cn: '圣赫勒拿、阿森松和特里斯坦-达库尼亚',
    code: 'SH',
    desc: 'St Helena',
    flag: '🇸🇭',
  },
  SI: { cn: '斯洛文尼亚', code: 'SI', desc: 'Slovenia', flag: '🇸🇮' },
  SJ: { cn: '斯瓦尔巴和扬马延', code: 'SJ', desc: 'Svalbard & Jan Mayen', flag: '🇸🇯' },
  SK: { cn: '斯洛伐克', code: 'SK', desc: 'Slovakia', flag: '🇸🇰' },
  SL: { cn: '塞拉利昂', code: 'SL', desc: 'Sierra Leone', flag: '🇸🇱' },
  SM: { cn: '圣马力诺', code: 'SM', desc: 'San Marino', flag: '🇸🇲' },
  SN: { cn: '塞内加尔', code: 'SN', desc: 'Senegal', flag: '🇸🇳' },
  SO: { cn: '索马里', code: 'SO', desc: 'Somalia', flag: '🇸🇴' },
  SR: { cn: '苏里南', code: 'SR', desc: 'Suriname', flag: '🇸🇷' },
  SS: { cn: '南苏丹', code: 'SS', desc: 'South Sudan', flag: '🇸🇸' },
  ST: { cn: '圣多美和普林西比', code: 'ST', desc: 'São Tomé & Príncipe', flag: '🇸🇹' },
  SV: { cn: '萨尔瓦多', code: 'SV', desc: 'El Salvador', flag: '🇸🇻' },
  SX: { cn: '荷属圣马丁', code: 'SX', desc: 'Sint Maarten', flag: '🇸🇽' },
  SY: { cn: '叙利亚', code: 'SY', desc: 'Syria', flag: '🇸🇾' },
  SZ: { cn: '斯威士兰', code: 'SZ', desc: 'Swaziland', flag: '🇸🇿' },
  TC: { cn: '特克斯和凯科斯群岛', code: 'TC', desc: 'Turks & Caicos Islands', flag: '🇹🇨' },
  TD: { cn: '乍得', code: 'TD', desc: 'Chad', flag: '🇹🇩' },
  TF: {
    cn: '法属南部和南极领地',
    code: 'TF',
    desc: 'French Southern Territories',
    flag: '🇹🇫',
  },
  TG: { cn: '多哥', code: 'TG', desc: 'Togo', flag: '🇹🇬' },
  TH: { cn: '泰国', code: 'TH', desc: 'Thailand', flag: '🇹🇭' },
  TJ: { cn: '塔吉克斯坦', code: 'TJ', desc: 'Tajikistan', flag: '🇹🇯' },
  TK: { cn: '托克劳', code: 'TK', desc: 'Tokelau', flag: '🇹🇰' },
  TL: { cn: '东帝汶', code: 'TL', desc: 'Timor-Leste', flag: '🇹🇱' },
  TM: { cn: '土库曼斯坦', code: 'TM', desc: 'Turkmenistan', flag: '🇹🇲' },
  TN: { cn: '突尼斯', code: 'TN', desc: 'Tunisia', flag: '🇹🇳' },
  TO: { cn: '汤加', code: 'TO', desc: 'Tonga', flag: '🇹🇴' },
  TR: { cn: '土耳其', code: 'TR', desc: 'Turkey', flag: '🇹🇷' },
  TT: { cn: '特立尼达和多巴哥', code: 'TT', desc: 'Trinidad & Tobago', flag: '🇹🇹' },
  TV: { cn: '图瓦卢', code: 'TV', desc: 'Tuvalu', flag: '🇹🇻' },
  TW: { cn: '中国台湾', code: 'TW', desc: 'Taiwan, Province of China', desc1: 'china', flag: '🇨🇳' },
  TZ: { cn: '坦桑尼亚', code: 'TZ', desc: 'Tanzania', flag: '🇹🇿' },
  UA: { cn: '乌克兰', code: 'UA', desc: 'Ukraine', flag: '🇺🇦' },
  UG: { cn: '乌干达', code: 'UG', desc: 'Uganda', flag: '🇺🇬' },
  UM: { cn: '美国本土外小岛屿', code: 'UM', desc: 'US Outlying Islands', flag: '🇺🇸' },
  US: { cn: '美国', code: 'US', desc: 'United States of America', flag: '🇺🇸' },
  UY: { cn: '乌拉圭', code: 'UY', desc: 'Uruguay', flag: '🇺🇾' },
  UZ: { cn: '乌兹别克斯坦', code: 'UZ', desc: 'Uzbekistan', flag: '🇺🇿' },
  VA: { cn: '梵蒂冈', code: 'VA', desc: 'Vatican City', flag: '🇻🇦' },
  VC: {
    cn: '圣文森特和格林纳丁斯',
    code: 'VC',
    desc: 'St Vincent & Grenadines',
    flag: '🇻🇨',
  },
  VE: { cn: '委内瑞拉', code: 'VE', desc: 'Venezuela', flag: '🇻🇪' },
  VG: { cn: '英属维尔京群岛', code: 'VG', desc: 'British Virgin Islands', flag: '🇻🇬' },
  VI: { cn: '美属维尔京群岛', code: 'VI', desc: 'US Virgin Islands', flag: '🇻🇮' },
  VN: { cn: '越南', code: 'VN', desc: 'Vietnam', flag: '🇻🇳' },
  VU: { cn: '瓦努阿图', code: 'VU', desc: 'Vanuatu', flag: '🇻🇺' },
  WF: { cn: '瓦利斯和富图纳', code: 'WF', desc: 'Wallis & Futuna', flag: '🇼🇫' },
  WS: { cn: '萨摩亚', code: 'WS', desc: 'Samoa', flag: '🇼🇸' },
  YE: { cn: '也门', code: 'YE', desc: 'Yemen', flag: '🇾🇪' },
  YT: { cn: '马约特', code: 'YT', desc: 'Mayotte', flag: '🇾🇹' },
  ZA: { cn: '南非', code: 'ZA', desc: 'South Africa', flag: '🇿🇦' },
  ZM: { cn: '赞比亚', code: 'ZM', desc: 'Zambia', flag: '🇿🇲' },
  ZW: { cn: '津巴布韦', code: 'ZW', desc: 'Zimbabwe', flag: '🇿🇼' },
  AC: { cn: '阿森松岛', code: 'AC', desc: 'Ascension Island', flag: '🇦🇨' },
  CP: { cn: '克利珀顿岛', code: 'CP', desc: 'Clipperton Island', flag: '🇨🇵' },
  DG: { cn: '迪戈加西亚岛', code: 'DG', desc: 'Diego Garcia', flag: '🇩🇬' },
  EA: { cn: '休达', code: 'EA', desc: 'Ceuta & Melilla', flag: '🇪🇦' },
  IC: { cn: '加那利群岛', code: 'IC', desc: 'Canary Islands', flag: '🇮🇨' },
  TA: { cn: '特里斯坦-达库尼亚', code: 'TA', desc: 'Tristan da Cunha', flag: '🇹🇦' },
}
